export class SsiTabItem {
    public Name: string;
    public Route: string;
    public Permission : string;
    public Url : string;
    public Data?: any;
    public isDisabled?: Boolean;
}
